import { helper } from '@ember/component/helper';

import { capitalize } from '@ember/string';

import strings from 'rise-ui/config/strings.js';

const blacklist = strings['title-case-blacklist'] || [];
const whitespace = /\s+/g;

export default helper(function titleCaseHelper([ title ]) {
  return title && (typeof title === 'string' ? title : ''+title).trim()
    .split(whitespace)
    .map((word, i) => i && blacklist.includes(word) ? word : capitalize(word))
    .join(' ');
});
